<template>
  <div>
    <el-table
        ref="tableSurveyForm"
        element-loading-spinner="el-icon-loading"
        :data="dataTable"
        border
        :max-height="$tableMaxHeight"
        :header-cell-style="headerCellStyle"
        :element-loading-text="$tableLoading"
        @selection-change="handleSelectionChange"
        element-loading-background="rgba(255,255,255, 0)"
        v-loading="isLoading"
    >
<!--      <el-table-column-->
<!--          type="selection"-->
<!--          width="50"-->
<!--          align="center"-->
<!--          fixed="left"-->
<!--      />-->

      <el-table-column
          type="index"
          label="STT"
          width="50"
          align="center"
          fixed="left"
      />

      <el-table-column
          label="Mã NV"
          width="100"
          align="center"
          fixed="left"
      >
        <template v-slot:default="scope">
          <span>{{scope.row.icode}}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Họ và tên"
          fixed="left"
      >
        <template v-slot:default="scope">
          <span>{{scope.row.fullName}}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Số điện thoại"
          width="160"
          align="center"
      >
        <template v-slot:default="scope">
          <span>{{scope.row.phone}}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Trạng thái"
          width="200"
          align="center"
      >
        <template v-slot:default="scope">
          <span :style="{color: scope.row.answer ? '#409EFF' : '#F56C6C'}">{{scope.row.answer ? "Đã trả lời" : "Chưa trả lời"}}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Ngày trả lời"
          width="200"
          align="center"
      >
        <template v-slot:default="scope">
          <span>{{scope.row.dateSeenAnswer}}</span>
        </template>
      </el-table-column>

      <el-table-column
          label="Tác vụ"
          width="240"
          align="center"
      >
        <template v-slot:default="scope">
          <div>
            <el-button :disabled="!scope.row.answer" @click="handleDetailAnswer(scope.row)" size="small" type="primary">
              Xem
            </el-button>

            <el-button :disabled="!scope.row.answer" @click="deleteAnswer(scope.row.id)" size="small" type="danger">
              Xoá
            </el-button>
          </div>
        </template>
      </el-table-column>

      <template #empty>
        <div style="text-align: center; font-size: 16px; color: #43a0ff;">
          <i class="el-icon-warning"></i>
          <span> Không có dữ liệu! </span>
        </div>
      </template>
    </el-table>

    <DetailAnswerSurveyForm
        :is-open="isOpenDialogDetailAnswer"
        @closeDialog="handleCloseDialogDetailAnswer"
        ref="detailAnswerSurveyForm"
    />
  </div>
</template>

<script>

import DetailAnswerSurveyForm from "@/views/survey_form/dialog/DetailAnswerSurveyForm.vue";
import SurveyForm from "@/services/SurveyForm";

const headerCellStyle = () => {
  return {
    backgroundColor: "#78a5e7",
    color: "#fff",
  }
}
export default {
  components: {DetailAnswerSurveyForm},
  props: {
    dataTable: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    idForm: {
      type: Number,
    },
    typeApply: {
      type: String,
      default: () => ""
    }
  },

  data() {
    return {
      isOpenDialogDetailAnswer: false,
    }
  },

  methods: {
    headerCellStyle,
    handleDetailAnswer(row) {
      const idForm = this.idForm;
      const typeUser = this.typeApply;
      this.isOpenDialogDetailAnswer = true;
      this.$refs.detailAnswerSurveyForm.handleInitialData(idForm, typeUser, row);
    },

    handleCloseDialogDetailAnswer() {
      this.isOpenDialogDetailAnswer = false;
    },

    deleteAnswer(id) {
      this.$confirm("Bạn có chắc chắn muốn xóa phần trả lời đã chọn?", "Thông báo!", {
        distinguishCancelAndClose: true,
        confirmButtonText: "Có",
        closeOnClickModal: false,
        cancelButtonText: "Không",
      })
          .then(() => {
            this.fetchDeleteAnswer(id);
          })
    },

    fetchDeleteAnswer(id) {
      const idForm = this.idForm;
      const typeUser = this.typeApply;

      SurveyForm.deleteDataAnswer(idForm, typeUser, id)
          .then((res) => {
            console.log(res.data.data);
            this.$message({
              message: res.data.message,
              type: "success"
            })
            this.$emit("resetData");
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Xoá dữ liệu không thành công!",
              type: "error"
            })
          })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>